import { render, staticRenderFns } from "./Cookie.vue?vue&type=template&id=448492d8&scoped=true"
import script from "./Cookie.vue?vue&type=script&lang=ts"
export * from "./Cookie.vue?vue&type=script&lang=ts"
import style0 from "./Cookie.vue?vue&type=style&index=0&id=448492d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448492d8",
  null
  
)

export default component.exports